<template>
  <div id="ScreenSecond">
    <div id="world-map">
      <DomeEchartWrap ref="world-map-2" id="world"></DomeEchartWrap>
    </div>
    <div class="content-wrap content-absolute">
      <h1 id="main-title">酷开态势感知</h1>
      <div class="content-left-wrap">
        <div class="lists-wrap">
          <div class="item" v-for="(item,index) in countryVOList" :key="index">
            <span class="name">{{ item.newMarket }}</span>
            <span
              class="terimal BoldAlternate"
              :class="{
                'terimal-hd':index===0
              }"
            >{{ numberSplitWithComma(item.totalNum) }}</span>
            <span
              class="daily  BoldAlternate"
              :class="{
                'daily-hd':index===0
              }"
            >{{ numberSplitWithComma(item.activeNum) }}</span>
          </div>
          <!-- <div class="item">
            <span class="name">东南亚</span>
            <span class="terimal BoldAlternate">5.63</span>
            <span class="daily BoldAlternate">4.81</span>
          </div>
          <div class="item">
            <span class="name">印度</span>
            <span class="terimal BoldAlternate">9.71</span>
            <span class="daily BoldAlternate">3.36</span>
          </div>
          <div class="item">
            <span class="name">欧洲</span>
            <span class="terimal BoldAlternate">0</span>
            <span class="daily BoldAlternate">0</span>
          </div>
          <div class="item">
            <span class="name">非洲</span>
            <span class="terimal BoldAlternate">0</span>
            <span class="daily BoldAlternate">0</span>
          </div> -->
        </div>
      </div>
      <div class="content-top-wrap">
        <!-- <p class="hd-title">数据概览(万)</p> -->
        <div class="data-wrap">
          <!-- <div class="item">
            <p class="name">本月营收</p>
            <span class="count BoldAlternate">4,977.1</span>
            <div class="super-name-wrap">
              <span class="super-name">本日营收</span>
              <span class="super-count">+1,201</span>
            </div>
          </div> -->
          <div class="item">
            <p class="name">累计激活终端数(万)</p>
            <span class="count BoldAlternate">{{ numberSplitWithComma(topLists.totalDeviceCount) }}</span>
            <!-- <div class="super-name-wrap">
              <span class="super-name">本日营收</span>
              <span class="super-count">+1,201</span>
            </div> -->
          </div>
          <div class="item">
            <p class="name">月活跃用户数(万)</p>
            <span class="count BoldAlternate">{{ numberSplitWithComma(topLists.activeUserCount) }}</span>
            <!-- <div class="super-name-wrap">
              <span class="super-name">本日营收</span>
              <span class="super-count">+1,201</span>
            </div> -->
          </div>
          <div class="item">
            <p class="name">月实时营收  (万)</p>
            <span class="count BoldAlternate">{{ numberSplitWithComma(topLists.monthIncome) }}</span>
            <!-- <div class="super-name-wrap">
              <span class="super-name">本日营收</span>
              <span class="super-count">+1,201</span>
            </div> -->
          </div>
        </div>
      </div>
      <div class="content-right-wrap">
        <div class="lists-wrap">
          <div class="item" v-for="item in rightContenLists" :key="item.name">
            <p class="hd-title">{{ item.title }}</p>
            <div class="item-content-data">
              <div class="item-content">
                <p class="name">累计覆盖家庭</p>
                <span class="count BoldAlternate">{{ numberSplitWithComma(item.left.val) }}</span>
              </div>
              <div class="item-content">
                <p class="name">月活跃</p>
                <span class="count BoldAlternate">{{ numberSplitWithComma(item.right.val) }}</span>
              </div>
            </div>
          </div>
          <!-- <div class="item">
            <p class="hd-title">商业</p>
            <div class="item-content-data">
              <div class="item-content">
                <p class="name">累计覆盖商业</p>
                <span class="count BoldAlternate">5,475</span>
              </div>
              <div class="item-content">
                <p class="name">月活跃</p>
                <span class="count BoldAlternate">3,231</span>
              </div>
            </div>
          </div>
          <div class="item">
            <p class="hd-title">办公</p>
            <div class="item-content-data">
              <div class="item-content">
                <p class="name">累计覆盖办公</p>
                <span class="count BoldAlternate">575</span>
              </div>
              <div class="item-content">
                <p class="name">月活跃</p>
                <span class="count BoldAlternate">126</span>
              </div>
            </div>
          </div>
          <div class="item">
            <p class="hd-title">社区</p>
            <div class="item-content-data">
              <div class="item-content">
                <p class="name">累计覆盖社区</p>
                <span class="count BoldAlternate">572</span>
              </div>
              <div class="item-content">
                <p class="name">月活跃</p>
                <span class="count BoldAlternate">421</span>
              </div>
            </div>
          </div>-->
        </div>
      </div>
      <div class="content-bot-wrap">
        <div class="lists-wrap">
          <div class="item" v-for="(item,index) in ottLists" :key="index">
            <div class="name">
              <span class="icon" :class="[`icon-${index+1}`]"></span>
              <span class="text">{{ item.name }}</span>
            </div>
            <span class="count BoldAlternate">{{ item.count }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import DomeEchartWrap from '@/components/echarts/DomeEchartWrap'
import { geoCoordMap, nameMap } from './js/CoutryCoord'
import common from '@/mixins/common.js'
import { MP } from '@/components/baiduMap'
import World from '@/assets/map/json/world-reserve.json'
export default {
  mixins: [common],
  name: 'ScreenSecond',
  props: [
    'screenSecondData'
  ],
  data () {
    return {
      topLists: {
        totalDeviceCount: 0,
        activeUserCount: 0,
        monthIncome: 0
      },
      ottLists: [
        {
          name: '商用屏',
          count: '577',
          key: 'businessCount'
        },
        {
          name: '车载',
          count: '4,895',
          key: 'carCount'
        },
        {
          name: 'STB',
          count: '61,599,042',
          key: 'stb'
        },
        {
          name: 'TV',
          count: '81,299,425',
          key: 'tv'
        },
        {
          name: '联动屏',
          count: '7,259,430',
          key: 'mobileCount'
        },

        {
          name: 'IOT',
          count: '110',
          key: 'iot'
        },
        {
          name: 'Miitee',
          count: '575',
          key: 'miiteeCount'
        }
      ],
      rightContenLists: [
        {
          title: '家庭(万)',
          left: {
            title: '累计覆盖家庭',
            key: 'homeTotalCount',
            val: 0
          },
          right: {
            title: '月活跃',
            key: 'homeActiveCount',
            val: 0
          }
        },
        {
          title: '商业',
          left: {
            title: '累计覆盖商业',
            key: 'businessCount',
            val: 0
          },
          right: {
            title: '月活跃',
            key: 'businessActiveCount',
            val: 0
          }
        },
        {
          title: '办公',
          left: {
            title: '累计覆盖办公',
            key: 'workTotalCount',
            val: 0
          },
          right: {
            title: '月活跃',
            key: 'workActiveCount',
            val: 0
          }
        },
        {
          title: '社区',
          left: {
            title: '累计覆盖社区',
            key: 'communityTotalCount',
            val: 0
          },
          right: {
            title: '月活跃',
            key: 'communityActiveCount',
            val: 0
          }
        }
      ],
      countryVOList: []
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    let vThat = this
    this.$refs['world-map-2'].registerMap(World)
    this.$refs['world-map-2'].setEchartOption({
      backgroundColor: '#0C1117',
      geo: {
        map: 'mapData',
        zoom: 1.25,
        top: vThat.fontSizeRem(10),
        center: [163.48, 31.22],
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 1,
            x2: 0,
            y2: 0,
            colorStops: [{
              offset: 0, color: 'RGBA(7, 41, 94, 1)' // 0% 处的颜色
            }, {
              offset: 1, color: 'RGBA(5, 48, 117, .4)' // 100% 处的颜色
            }]
          },
          borderColor: '#0150CA',
          borderWidth: 1,
          shadowColor: '#053074FF',
          shadowBlur: 40,
          shadowOffsetX: 10,
          shadowOffsetY: 10
        }
      },
      series: this.initSeries()
    })
  },
  watch: {
    screenSecondData: {
      handler: function (newValue, oldValue) {
        if (!newValue) { return }
        let { activeUserCount, totalDeviceCount, countryVOList, deviceVO, monthIncome, ...arg } = newValue?.worldVO ?? {}
        this.setTopLists(activeUserCount, totalDeviceCount, monthIncome)
        this.setRight(deviceVO)
        this.setCountryVOList(countryVOList)
        this.setOttLists(arg)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    initSeries () {
      let toData = [
        [
          { name: 'CHINASHENZHEN' },
          [{
            name: 'FRA',
            // 这里为自定义数据，tooltip会用到。
            value: {
              tradingCountry: '法国',
              total: '1200万美元',
              tradingNum: '5',
              table: [
                {
                  tradeEnterprises: '内蒙古xx有限公司',
                  shopping: '乘用车',
                  mode: '进口',
                  money: '90'
                },
                {
                  tradeEnterprises: '内蒙古xx有限公司',
                  shopping: '发动机',
                  mode: '出口',
                  money: '60'
                }
              ]
            }
          }, {
            name: 'RUS',
            // 这里为自定义数据，tooltip会用到
            value: {
              tradingCountry: '俄罗斯',
              total: '200万美元',
              tradingNum: '18',
              table: [
                {
                  tradeEnterprises: '内蒙古xx有限公司',
                  shopping: '乘用车',
                  mode: '进口',
                  money: '34'
                },
                {
                  tradeEnterprises: '内蒙古xx有限公司',
                  shopping: '发动机',
                  mode: '出口',
                  money: '40'
                }
              ]
            }
          }, {
            name: 'BEIJING',
            // 这里为自定义数据，tooltip会用到
            value: {
              tradingCountry: '北京',
              total: '200万美元',
              tradingNum: '18',
              table: [
                {
                  tradeEnterprises: '内蒙古xx有限公司',
                  shopping: '乘用车',
                  mode: '进口',
                  money: '34'
                },
                {
                  tradeEnterprises: '内蒙古xx有限公司',
                  shopping: '发动机',
                  mode: '出口',
                  money: '40'
                }
              ]
            }
          }, {
            name: 'Sydney',
            // 这里为自定义数据，tooltip会用到
            value: {
              tradingCountry: '悉尼',
              total: '200万美元',
              tradingNum: '18',
              table: [
                {
                  tradeEnterprises: '内蒙古xx有限公司',
                  shopping: '乘用车',
                  mode: '进口',
                  money: '34'
                },
                {
                  tradeEnterprises: '内蒙古xx有限公司',
                  shopping: '发动机',
                  mode: '出口',
                  money: '40'
                }
              ]
            }
          }]
        ]
      ]
      let series = []
      let datas = [['Peking', toData]]
      // 点之间
      const convertData = (data) => {
        var fromCoord = geoCoordMap[data[0][0].name]
        let res = []
        for (var i = 0; i < data[0][1].length; i++) {
          let dataIndex = data[0][1][i]
          var toCoord = geoCoordMap[dataIndex.name]
          if (fromCoord && toCoord) {
            res.push([
              {
                coord: fromCoord
              },
              {
                coord: toCoord
              }
            ])
          }
        }
        return res
      }

      datas.forEach((item, index) => {
        series.push({
          name: item[0],
          type: 'lines',
          coordinateSystem: 'geo',
          zlevel: 1,
          effect: {
            show: true,
            period: 4, // 箭头指向速度，值越小速度越快
            trailLength: 0.02, // 特效尾迹长度[0,1]值越大，尾迹越长重
            symbol: 'arrow', // 箭头图标
            symbolSize: 3 // 图标大小
          },
          lineStyle: {
            color: '#1DE9B6',
            width: 0.1, // 尾迹线条宽度
            opacity: 0, // 尾迹线条透明度
            curveness: 0.3 // 尾迹线条曲直度
          },
          data: convertData(item[1])
        }, {
          type: 'effectScatter', // 带有涟漪特效动画的散点（气泡）图
          coordinateSystem: 'geo',
          zlevel: 2,
          symbol: 'circle',
          symbolSize: 10,
          // 涟漪特效
          rippleEffect: {
            period: 4,
            scale: 4,
            brushType: 'stroke'
          },
          itemStyle: {
            color: 'rgb(62,212,255)'
          },
          label: {
            show: true,
            color: '#fff',
            position: 'bottom',
            fontSize: 16,
            formatter: function (item) {
              if (!item.data.datas) { return nameMap[item.name] }
              return item.data.datas.tradingCountry
            }
          },
          // 这里用来组装自定义数据，以便在tooltip中取得。
          data: item[1].reduce((newArrParent, NextItem, NextItemIndex) => {
            let a = NextItem.reduce((newArr, dataItem, indexA) => {
              if (indexA === 0) {
                newArr.push({
                  name: dataItem.name,
                  value: geoCoordMap[dataItem.name],
                  datas: dataItem.value
                })
              } else {
                newArr.push(...dataItem.map(itemA => {
                  return {
                    name: itemA.name,
                    value: geoCoordMap[itemA.name],
                    datas: itemA.value
                  }
                }))
              }
              return newArr
            // return {
            //   name: dataItem[1].name,
            //   value: geoCoordMap[dataItem[1].name],
            //   datas: dataItem[1].value
            // }
            }, [])
            newArrParent.push(...a)
            return newArrParent
          }, [])
        })
      })
      return series
    },
    setTopLists (activeUserCount, totalDeviceCount, monthIncome) {
      this.topLists.totalDeviceCount = totalDeviceCount
      this.topLists.activeUserCount = activeUserCount
      this.topLists.monthIncome = monthIncome
    },
    setRight (val = {}) {
      this.rightContenLists.forEach(item => {
        item.left.val = val[item.left.key] ?? 0
        item.right.val = val[item.right.key] ?? 0
      })
    },
    setOttLists (val = {}) {
      this.ottLists.forEach(item => {
        item.count = this.numberSplitWithComma(val[item.key] ?? 0)
      })
    },
    setCountryVOList (val = []) {
      this.countryVOList = val
    }
  },
  components: {
    DomeEchartWrap
  }
}
</script>

<style scoped lang="stylus">
#ScreenSecond
  height: 75.8rem
  width 100%
  position relative
  display flex
  align-items: center
  justify-content: center
.content-absolute
  position: absolute
  top: 0
  left: 0
  bottom 0
  right 0
  .content-left-wrap
    color: rgba(255, 255, 255, 1)
    position: absolute
    left: 1rem
    top 50%
    transform translateY(-50%)
    padding 3.58rem 1.25rem
    background rgba(255, 255, 255, 0.1)
    border-radius 0.75rem
    background-filter blur(12.5rem)
    .lists-wrap
      padding-top 2rem
      .name
        margin-right 1rem
        font-size 1.88rem
        min-width 6rem
      .terimal
        margin-right: 2rem
      .terimal,.daily
        font-size 1.5rem
        min-width: 6rem
        text-align center
      .item+.item
        margin-top: 1.25rem
      span
        display inline-block
  .item-title
    font-size: 1.25rem
    color: rgba(255, 255, 255, .8)
    display: flex
    .terimal
      margin-left: auto
    .terimal,.daily
      text-align center
      min-width 35%

.content-top-wrap
  color: rgba(255, 255, 255, 1)
  position: absolute
  left: 50%
  top 6rem
  transform translateX(-50%)
  padding 1.25rem
  background rgba(255, 255, 255, 0.1)
  border-radius 0.75rem

.terimal-hd
  position: relative

.terimal-hd::before
  content "终端总量(万)"
  position absolute
  left: 0
  right 0
  white-space nowrap
  font-size 1.25rem
  top -2rem
  color rgba(255, 255, 255, 0.8)
.daily-hd
  position: relative
.daily-hd::before
  content "月活跃(万)"
  position absolute
  left: 0
  right 0
  white-space nowrap
  font-size 1.25rem
  top -2rem
  color rgba(255, 255, 255, 0.8)

.content-top-wrap
  .hd-title
    color: #fff
    font-size 2rem
    margin-bottom: 1.25rem
  .data-wrap
    display: flex
    .name
      font-size: 1.25rem
      color: rgba(255, 255, 255, 0.8)
      margin-bottom: .25rem
    .count
      font-size: 2.38rem
      color: rgba(255, 255, 255, 1)
      margin-bottom: .25rem
      display inline-block
      i
        font-family normal
        font-size: 1.5rem
    .super-name-wrap
      font-size 0.88
      color: rgba(255, 255, 255,0.8)
      .super-count
        color rgba(24, 105, 255, 1)
    .item+.item
      margin-left: 3rem

.content-right-wrap
  color: rgba(255, 255, 255, 1)
  position: absolute
  top: 50%
  right 1rem
  transform translateY(-50%)
  padding 2.5rem 1rem
  background rgba(255, 255, 255, 0.1)
  border-radius 0.75rem
  background-filter blur(12.5rem)
  .lists-wrap
    .hd-title
      font-size: 1.88rem
      color: rgba(255, 255, 255,1)
      margin-bottom: .75rem
    .item-content-data
      display: flex
      .item-content+.item-content
        margin-left: 1rem
      .name
        font-size: 1rem
        color: rgba(255, 255, 255,.8)
        margin-bottom: .25rem
      .count
        font-size: 1.5rem
        color: rgba(255, 255, 255, 1)
    .item+.item
      margin-top 1.5rem
.content-bot-wrap
  color: rgba(255, 255, 255, 1)
  position: absolute
  left: 50%
  bottom 2rem
  transform translateX(-50%)
  .lists-wrap
    display: flex
    .item+.item
      margin-left 1rem
    .item
      background rgba(255, 255, 255, 0.1)
      border-radius 0.75rem
      background-filter blur(12.5rem)
      width 13.75rem
      height 6.63rem
      display flex
      flex-direction: column
      justify-content: center
      align-items: center
      color: rgba(255, 255, 255, 1)
      .name
        margin-bottom: .5rem
        display: flex
        align-items: center
        .icon
          display inline-block
          width .75rem
          height .75rem
          border-radius: 50%
          overflow hidden
          margin-right: .5rem
        .text
          font-size: 1.88rem
      .count
        font-size: 1.5rem
      .icon-1
        background-color: rgba(71, 191, 100, 1)
      .icon-2
        background-color: rgba(255, 218, 58, 1)
      .icon-3
        background-color: rgba(255, 95, 165, 1)
      .icon-4
        background-color: rgba(167, 74, 255, 1)
      .icon-5
        background-color: rgba(255, 138, 48, 1)
      .icon-6
        background-color: rgba(0, 114, 255, 1)
      .icon-7
        background-color: rgba(0, 211, 200, 1)

#world-map
  width 100rem
  height 90%
  align-items: center
#main-title
  font-size: 3.5rem
  position relative
  text-align: center
  color: #fff
  letter-spacing: 1rem
</style>
